document.addEventListener('DOMContentLoaded', function() {
  const content = document.querySelector('.entry-content');
  const images  = content.querySelectorAll('figure img');
  const body    = document.querySelector('body');

  images.forEach(item => item.addEventListener('click', zoomImage));

  function zoomImage(e) {
    const cloneImg = e.target.cloneNode(true);
    const modal    = document.createElement('dialog');
    modal.appendChild(cloneImg);
    content.appendChild(modal);
    modal.showModal();
    body.style.overflowY = 'hidden'

    modal.addEventListener('click', e => {
      modal.close();
			modal.remove();
      body.style.overflowY = 'auto';
    });
  }
});
